<template>
  <div v-if="!userReviewed">
    <div class="fe-text-heading-xxs lg:fe-text-heading-xs fe-mb-xxs lg:fe-mb-m">
      {{ writeReviewTitle }}
    </div>
    <div
      class="fe-text-body-xxs lg:fe-text-body-s fe-text-primary-grey-80 fe-mb-s"
    >
      {{ writeReviewHelpText }}
    </div>

    <div class="fe-mb-base">
      <CustomFdkAccount v-slot="accountsData">
        <StarRating
          :readOnly="userReviewed"
          @updateRating="
            (selectedStar) => openAddReviewModal(accountsData, selectedStar)
          "
          :initialRating="rating"
          size="xxl"
          className="sm:fe-gap-base lg:fe-justify-between"
          :key="starRatingRerenderKey"
        />
      </CustomFdkAccount>
    </div>

    <div>
      <CustomFdkAccount v-slot="accountsData">
        <JdsButton
          :fullWidth="true"
          variant="secondary"
          size="large"
          @click="openAddReviewModal(accountsData)"
        >
          {{ writeReviewCta }}
        </JdsButton>
      </CustomFdkAccount>
    </div>
  </div>
</template>

<script>
  import StarRating from "@/components/DesignSystem/StarRating/StarRating.vue"
  import CustomFdkAccount from "@/components/Utilities/CustomFdkAccount/CustomFdkAccount.vue"
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import AddEditReview from "@/components/ReviewAndRating/AddEditReview/AddEditReview.vue"
  import { modalMixin } from "@/mixins/modalMixin"
  import { customerLoginHandler, translate } from "@/utils/utils"
  import { TRANSLATION_KEYS } from "@/constants/translationKeys"

  export default {
    name: "RatingCta",
    components: { CustomFdkAccount, StarRating, JdsButton },
    mixins: [modalMixin],
    inject: ["globalState"],
    data() {
      return {
        starRatingRerenderKey: 0,
      }
    },
    computed: {
      userReviewed() {
        return this.globalState.userReviewed
      },
      rating() {
        return this.globalState.rating || 0
      },
      writeReviewTitle() {
        return translate(TRANSLATION_KEYS.WRITE_REVIEW_TITLE)
      },
      writeReviewHelpText() {
        return translate(TRANSLATION_KEYS.WRITE_REVIEW_HELP)
      },
      writeReviewCta() {
        return translate(TRANSLATION_KEYS.WRITE_REVIEW_CTA)
      },
    },
    methods: {
      openAddReviewModal(accountsData, selectedStar) {
        if (!accountsData?.is_logged_in) {
          customerLoginHandler(accountsData)
        } else {
          this.openModal(AddEditReview, {
            selectedRating: selectedStar || 0,
          })
        }

        this.starRatingRerenderKey += 1
      },
    },
  }
</script>
